(() => {
  const syncHeight = () => { const h = document.querySelector('.dc-sticky-header'); if (h) document.documentElement.style.setProperty('--dc-header-height', `${Math.ceil(h.getBoundingClientRect().height)}px`); };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', syncHeight, {once:true}); else syncHeight();
  if (typeof ResizeObserver !== 'undefined') { const run = () => { const header = document.querySelector('.dc-sticky-header'); if (header) new ResizeObserver(syncHeight).observe(header); }; if (document.readyState==='loading') document.addEventListener('DOMContentLoaded',run,{once:true}); else run(); }
  window.addEventListener('resize',syncHeight);

  const selectors = '.dc-art-nav details, .dc-sticky-header details';
  const allMenus = () => Array.from(document.querySelectorAll(selectors));
  const closeExcept = (except) => { for (const menu of allMenus()) if (menu !== except && !(except && menu.contains(except))) menu.open = false; };
  document.addEventListener('toggle', event => {
    const menu = event.target;
    if (!(menu instanceof HTMLDetailsElement) || !menu.matches(selectors) || !menu.open) return;
    closeExcept(menu);
  }, true);
  document.addEventListener('click', event => {
    const menus = allMenus();
    const clickedLink = event.target.closest('a');
    if (clickedLink && clickedLink.closest('.dc-art-nav, .dc-sticky-header')) {
      closeExcept(null);
      return;
    }
    if (event.target.closest(selectors)) return;
    closeExcept(null);
  });
  document.addEventListener('keydown', event => {
    if (event.key !== 'Escape') return;
    const opened = allMenus().filter(menu => menu.open);
    if (!opened.length) return;
    const active = document.activeElement;
    opened.forEach(menu => { menu.open = false; });
    if (active && active.closest && active.closest(selectors)) {
      const summary = active.closest('details').querySelector('summary');
      if (summary) summary.focus();
    }
  });
  window.addEventListener('pageshow', () => closeExcept(null));
})();